/**
 * canvas对象容器
 */
export default {
	
}